import React, { useState } from 'react';
import CommonButton from '../elments/CommonButton';
import './styles/TableTabs.css';

// Renders one tab per table when a question produces more than one table,
// showing only the selected table's content. Falls back to rendering the
// single table directly (no tab bar) when there is only one.
const TableTabs = ({ tabs }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  if (!tabs || tabs.length === 0) return null;
  if (tabs.length === 1) return <>{tabs[0].content}</>;

  const safeActiveIndex = activeIndex < tabs.length ? activeIndex : 0;

  return (
    <div className="table-tabs">
      <div className="table-tabs__nav">
        {tabs.map((tab, index) => (
          <CommonButton
            key={tab.key ?? index}
            title={`Switch to ${tab.label}`}
            label={tab.label}
            onClick={() => setActiveIndex(index)}
            variant="tab"
            size="small"
            isSelected={index === safeActiveIndex}
          />
        ))}
      </div>
      <div className="table-tabs__panel">
        {tabs[safeActiveIndex].content}
      </div>
    </div>
  );
};

export default TableTabs;
